import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './BottomNavigation.css';

export const BottomNavigation: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    {
      id: 'home',
      title: 'Ху#ки',
      icon: '/nav-collection.png',
      path: '/'
    },
    {
      id: 'my-nfts',
      title: 'Мои ху#ки',
      icon: '/nav-my.png',
      path: '/my-nfts'
    },
    {
      id: 'my-drops',
      title: 'Дропы',
      icon: '/nav-drop.png',
      path: '/my-drops'
    },
    {
      id: 'shop',
      title: 'Магазин',
      icon: '/nav-shop.png',
      path: '/shop'
    },
    {
      id: 'profile',
      title: 'Профиль',
      icon: '/nav-profile.png',
      path: '/profile'
    }
  ];

  const handleNavClick = (path: string) => {
    navigate(path);
  };

  return (
    <div className="bottom-navigation">
      <div className="nav-container">
          {navItems.map((item) => {
            const active = item.path === '/shop'
              ? location.pathname === '/shop'
                || location.pathname.startsWith('/shop/')
                || location.pathname.startsWith('/purchases/')
              : location.pathname === item.path;

            return (
              <button
                key={item.id}
                className={`nav-item ${active ? 'active' : ''}`}
                onClick={() => handleNavClick(item.path)}
              >
                <div
                  className="nav-icon"
                  style={{
                    WebkitMaskImage: `url(${item.icon})`,
                    maskImage: `url(${item.icon})`,
                  }}
                />
                <span className="nav-title">{item.title}</span>
              </button>
            );
          })}
      </div>
    </div>
  );
};
